import React, { useState, useEffect } from 'react';
import { Select, Divider, Input, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
// import 'antd/dist/antd.css';
import './EditableSelect.scss';

const { Option } = Select;
const ADD_ITEM_DEFAULT_LABEL = 'Add item';
const PLACEHOLDER_DEFAULT_LABEL = 'Select an Item';

const EditableSelect = (props) => {
	const ADD_ITEM_LABEL = props.addItemLabel || ADD_ITEM_DEFAULT_LABEL;
	const PLACEHOLDER_LABEL = props.placeholder || PLACEHOLDER_DEFAULT_LABEL;

	const [items, setItems] = useState([]);
	const [name, setName] = useState(null);
	const [selectedValueObj, setSelectedValueObj] = useState(null);

	useEffect(() => {
		if (props.defaultItems && props.defaultItems.length) {
			setItems(props.defaultItems);

			let selectedDefaultValueIndex = props.defaultItems.findIndex((itemObj) => itemObj.isDefault);
			if (selectedDefaultValueIndex > -1) {
				setSelectedValueObj(props.defaultItems[selectedDefaultValueIndex]);
			}
		}
	}, [props.defaultItems]);

	useEffect(() => {
		props.onChange(items);
	}, [items]);

	useEffect(() => {
		if (props.isResetValueWhenDisabled) {
			setSelectedValueObj(null);
		}
	}, [props.isResetValueWhenDisabled]);

	const onNameChange = (event) => {
		setName(event.target.value);
	};

	const onOptionSelected = (selectedValue) => {
		let cloneItems = [...items];
		let prevSelectedDefaultValueIndex = cloneItems.findIndex((itemObj) => itemObj.isDefault);
		if (prevSelectedDefaultValueIndex > -1) {
			delete cloneItems[prevSelectedDefaultValueIndex].isDefault;
		}
		let selectedDefaultValueIndex = cloneItems.findIndex((itemObj) => itemObj.value === selectedValue);
		if (selectedDefaultValueIndex > -1) {
			cloneItems[selectedDefaultValueIndex].isDefault = true;
			setSelectedValueObj(cloneItems[selectedDefaultValueIndex]);
		}

		props.onChange(cloneItems);
	};

	const addItem = () => {
		if (!!name) {
			setItems([...items, { value: name, display: name }]);
			setName(null);
		}
	};

	const getTitle = () => {
		if (props.title) {
			return <div className="select-field-title">{props.title}</div>;
		}
	};

	return (
		<div className={props.className}>
			<Tooltip placement="topLeft" title={props.tooltip}>
				{getTitle()}
			</Tooltip>
			<Select
				style={{ width: '100%' }}
				disabled={props.disabled}
				value={selectedValueObj}
				defaultValue={!!props.selectedDefaultValue ? props.selectedDefaultValue.value : null}
				placeholder={PLACEHOLDER_LABEL}
				onSelect={(e) => onOptionSelected(e)}
				dropdownRender={(menu) => (
					<div>
						{menu}
						<Divider style={{ margin: '4px 0' }} />
						<div style={{ flexWrap: 'nowrap', padding: 8 }}>
							<Input style={{ flex: 'auto' }} value={name} onChange={(e) => onNameChange(e)} />
							<a
								style={{
									flex: 'none',
									padding: '8px',
									display: 'block',
									cursor: 'pointer',
								}}
								onClick={() => addItem()}
							>
								<PlusOutlined /> {ADD_ITEM_LABEL}
							</a>
						</div>
					</div>
				)}
			>
				{items.map((itemObj, index) => (
					<Option value={itemObj.value} key={index}>
						{itemObj.display}
					</Option>
				))}
			</Select>
		</div>
	);
};

export default React.memo(EditableSelect);
